import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// To regenerate from source svgs in src/UILibrary/icons/svgs/*.svg
// run make generate-icons
import { NessieThemeColors } from "src/UILibrary/theme";
import { Box } from "UILibrary";
type CheckmarkIconProps = React.SVGProps<SVGSVGElement> & {
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
  customSize?: string;
  color?: NessieThemeColors;
  onClick?: () => void;
  cursor?: React.CSSProperties["cursor"];
  display?: React.CSSProperties["display"];
  "data-test-name"?: string;
};

const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({
  size = "m",
  color = "inherit",
  customSize,
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ...props
}) => {
  const sizeInPixels = customSize ? customSize : SIZES[size];
  return (
    <Box
      data-test-name={dataTestName}
      onClick={onClick}
      display={display}
      color={color}
      cursor={cursor}
      fontSize={sizeInPixels}
      lineHeight={0}
      position="relative"
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M8.421 19.122a1.996 1.996 0 001.565-.58L20.434 8.093a2 2 0 10-2.828-2.828L8.421 14.45 5.443 11.47A2 2 0 102.614 14.3l4.243 4.242a1.996 1.996 0 001.564.58z" />
        </svg>
      }
    </Box>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
export default CheckmarkIcon;
